/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CmsArticlesIndexData,
  CmsArticlesIndexParams,
  CmsArticlesStoreData,
  CmsArticlesStoreTypeEnum1,
  GetBannerData,
  GetBannerParams,
  GetBrandCardListData,
  GetBrandCardListParams,
  GetCarouselData,
  GetCarouselParams,
  GetCmsHeaderPillsData,
  GetConnectedHomepageConfigurationData,
  GetConnectedHomepageRecommendationsData,
  GetConnectedHomepageRecommendationsParams,
  GetProductCardListData,
  GetProductCardListParams,
  GetToplineBannerData,
  GetUnconnectedFooterData,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Cms<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
 * @description Get connected homepage configuration
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetConnectedHomepageConfiguration
 * @summary Get connected homepage configuration
 * @request GET:/api/internal/v1/cms/connected-homepage-configuration
 * @response `200` `GetConnectedHomepageConfigurationData` Configuration of connected homepage
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getConnectedHomepageConfiguration = (params: RequestParams = {}) =>
    this.request<
      GetConnectedHomepageConfigurationData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/connected-homepage-configuration`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Get connected homepage recommendations
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetConnectedHomepageRecommendations
 * @summary Get connected homepage recommendations
 * @request GET:/api/internal/v1/cms/connected-homepage-recommendations
 * @response `200` `GetConnectedHomepageRecommendationsData` Recommendations for the connected homepage
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getConnectedHomepageRecommendations = (query: GetConnectedHomepageRecommendationsParams, params: RequestParams = {}) =>
    this.request<
      GetConnectedHomepageRecommendationsData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/connected-homepage-recommendations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Get brand card list
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetBrandCardList
 * @summary Get brand card list
 * @request GET:/api/internal/v1/cms/specific-carousel/brand-card
 * @response `200` `GetBrandCardListData` Brand Card Response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getBrandCardList = (query: GetBrandCardListParams, params: RequestParams = {}) =>
    this.request<
      GetBrandCardListData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/specific-carousel/brand-card`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Get product card list
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetProductCardList
 * @summary Get product card list
 * @request GET:/api/internal/v1/cms/specific-carousel/product-card
 * @response `200` `GetProductCardListData` Product Card Response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getProductCardList = (query: GetProductCardListParams, params: RequestParams = {}) =>
    this.request<
      GetProductCardListData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/specific-carousel/product-card`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Get carousel
 *
 * @tags AnkorstoreInternal_Carousel
 * @name GetCarousel
 * @summary Get carousel
 * @request GET:/api/internal/v1/cms/carousel
 * @response `200` `GetCarouselData` Single carousel response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getCarousel = (query: GetCarouselParams, params: RequestParams = {}) =>
    this.request<
      GetCarouselData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/carousel`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Get unconnected footer
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetUnconnectedFooter
 * @summary Get unconnected footer
 * @request GET:/api/internal/v1/cms/footer
 * @response `200` `GetUnconnectedFooterData` Footer for unconnected homepage
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getUnconnectedFooter = (params: RequestParams = {}) =>
    this.request<
      GetUnconnectedFooterData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/footer`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Returns header pill information for the authenticated retailer. This includes: - Ankorstore Plus opt-in status - Pill information (promocode for first checkout) - Credit limit information - Business verification status All attributes are conditionally included: only present when the value is not null.
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetCmsHeaderPills
 * @summary Get header pills for the authenticated retailer
 * @request GET:/api/internal/v1/cms/header-pills
 * @response `200` `GetCmsHeaderPillsData` Header pills resource response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getCmsHeaderPills = (params: RequestParams = {}) =>
    this.request<
      GetCmsHeaderPillsData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/header-pills`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Get banner
 *
 * @tags AnkorstoreInternal_Banner
 * @name GetBanner
 * @summary Get banner
 * @request GET:/api/internal/v1/cms/banner
 * @response `200` `GetBannerData` Single banner response
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `404` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not found
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getBanner = (query: GetBannerParams, params: RequestParams = {}) =>
    this.request<
      GetBannerData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/banner`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
 * @description Returns the currently active topline banner configuration, or 204 if no banner is active.
 *
 * @tags AnkorstoreInternal_Cms
 * @name GetToplineBanner
 * @summary Get active topline banner
 * @request GET:/api/internal/v1/cms/topline-banner
 * @response `200` `GetToplineBannerData` Active topline banner
 * @response `204` `void` No active topline banner
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  getToplineBanner = (params: RequestParams = {}) =>
    this.request<
      GetToplineBannerData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/topline-banner`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
 * @description Creates a new Article in Draft status, submitted by AksWriter (the weekly changelog automation service). The article is created with `status: draft` and must go through the BO review workflow (submit for review / publish) before it appears publicly. Authenticated via machine-to-machine JWT (`auth:machine`), restricted to the `akswriter` client id only.
 *
 * @tags AnkorstoreInternal_Cms
 * @name CmsArticlesStore
 * @summary Submit a weekly changelog draft
 * @request POST:/api/internal/v1/cms/articles
 * @response `201` `CmsArticlesStoreData` Article created (JSON:API resource)
 * @response `401` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unauthorized
 * @response `403` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Forbidden
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 * @response `422` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unprocessable Entity : Data provided is invalid
 * @response `500` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Server Error
 */
  cmsArticlesStore = (
    data: {
      data: {
        type: CmsArticlesStoreTypeEnum1;
        attributes: {
          /** Article title, one entry per locale (all 5 required) */
          title: {
            en: string;
            fr: string;
            de: string;
            es: string;
            it: string;
          };
          /** Article body, one entry per locale (all 5 required) */
          body: {
            en: string;
            fr: string;
            de: string;
            es: string;
            it: string;
          };
          /** Merged pull requests that contributed to this draft (can be empty) */
          sources?:
            | {
                /** @example 55488 */
                number: number;
                /** @example "fix(PRICE-34): ..." */
                title: string;
                /**
                 * @format uri
                 * @example "https://github.com/ankorstore/ankorstore/pull/55488"
                 */
                url: string;
                /** @format date-time */
                merged_at: string;
              }[]
            | null;
        };
      };
    },
    params: RequestParams = {}
  ) =>
    this.request<
      CmsArticlesStoreData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/articles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
 * @description Public, unauthenticated endpoint returning published changelog articles only. Draft and in_review articles are never returned, and this cannot be widened by a filter — `status` is hard-scoped server-side. `title`/`body`/`excerpt` are resolved to the current request locale (via the standard locale-detection already used by other public Cms endpoints), falling back to English when a locale's translation is missing. The raw multi-locale content and the internal `sources` metadata are never exposed. Results are paginated (15 per page by default) and sorted newest-published-first.
 *
 * @tags AnkorstoreInternal_Cms
 * @name CmsArticlesIndex
 * @summary List published articles
 * @request GET:/api/internal/v1/cms/articles
 * @response `200` `CmsArticlesIndexData` Paginated list of published articles (JSON:API collection)
 * @response `406` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Not Acceptable
 * @response `415` `{
  \** @uniqueItems true *\
    errors: ({
  \** An application-specific error code, expressed as a string value. *\
    code?: string,
  \** A human-readable explanation specific to this occurrence of the problem. *\
    detail?: string,
  \** The HTTP status code applicable to this problem, expressed as a string value. *\
    status?: string,
  \** The HTTP status code description applicable to this problem *\
    title?: string,
  \** Optional object pointing towards the problematic field *\
    source?: {
  \** The field key *\
    pointer?: string,

},

})[],
  \** An object describing the server's implementation *\
    jsonapi?: {
  \** @example "1.0" *\
    version?: string,
  \** Non-standard meta-information that can not be represented as an attribute or relationship. *\
    meta?: Record<string,any>,

},

}` Unsupported Media Type
 */
  cmsArticlesIndex = (query: CmsArticlesIndexParams, params: RequestParams = {}) =>
    this.request<
      CmsArticlesIndexData,
      {
        /** @uniqueItems true */
        errors: {
          /** An application-specific error code, expressed as a string value. */
          code?: string;
          /** A human-readable explanation specific to this occurrence of the problem. */
          detail?: string;
          /** The HTTP status code applicable to this problem, expressed as a string value. */
          status?: string;
          /** The HTTP status code description applicable to this problem */
          title?: string;
          /** Optional object pointing towards the problematic field */
          source?: {
            /** The field key */
            pointer?: string;
          };
        }[];
        /** An object describing the server's implementation */
        jsonapi?: {
          /** @example "1.0" */
          version?: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      }
    >({
      path: `/api/internal/v1/cms/articles`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
